'use client';
import CheckoutCard from '@components/checkout/checkout-card';
import Container from '@components/ui/container';
import CheckoutDetails, {
  CheckoutDetailsCompletedProps,
} from '@components/checkout/checkout-details';
import Divider from '@components/ui/divider';
import { Nullable } from '@framework/types';
import { useState } from 'react';
import { useRouteLang } from 'src/hooks/use-route-lang';
import { useAuthContext } from '@contexts/use-auth-context';
import { Navigate } from 'react-router-dom';

export default function CheckoutPageContent() {
  const lang = useRouteLang();
  const [checkoutDetails, setCheckout] =
    useState<Nullable<CheckoutDetailsCompletedProps>>();

  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    return <Navigate to={`/${lang}`} replace={true} />;
  }

  return (
    <>
      <Divider />
      <Container className="py-10 2xl:py-12 checkout">
        <div className="flex flex-col mx-auto xl:max-w-screen-xl">
          <div className="flex flex-col flex-wrap grid-cols-1 gap-x-7 xl:gap-x-8 lg:grid lg:grid-cols-12">
            {!checkoutDetails && (
              <div className="w-full col-start-1 col-end-13">
                <CheckoutDetails
                  lang={lang}
                  onCheckoutDetailsComplete={setCheckout}
                />
              </div>
            )}
            {checkoutDetails && (
              <div className="w-full col-start-1 col-end-13 mt-7 lg:mt-0">
                <CheckoutCard checkoutDetails={checkoutDetails} lang={lang} />
              </div>
            )}
          </div>
        </div>
      </Container>
      <Divider />
    </>
  );
}
